import { motion } from "framer-motion";
import {
  MapPin,
  Waves,
  School,
  ShoppingBag,
  Film,
  Hospital,
  Car,
  Wifi,
  Zap,
  Building2,
  Briefcase,
  HeartPulse,
} from "lucide-react";

export default function Location() {
  const locations = [
    {
      icon: <MapPin size={20} />,
      text: "25 min (30 km) drive from Baku city center",
    },
    { icon: <Waves size={20} />, text: "10 min from the Caspian Sea" },
    {
      icon: <School size={20} />,
      text: "Top schools nearby: Landau, Sabis Sun, KinderLand, SummerSchool.az",
    },
    {
      icon: <ShoppingBag size={20} />,
      text: "Shopping & dining: Amburan Mall, Sea Breeze, Dukkan Organic, McDonald's",
    },
    {
      icon: <Film size={20} />,
      text: "Entertainment: Park Cinema, CinemaPlus, Amburan Mall, Largest aqua park in the Caucasus",
    },
    {
      icon: <Hospital size={20} />,
      text: "Medical facilities: hospitals, 24/7 clinics, pharmacies",
    },
    {
      icon: <Car size={20} />,
      text: "Taxi & delivery services: Wolt, Bolt, Uber available 24/7",
    },
    { icon: <Wifi size={20} />, text: "5 high-speed optic internet providers" },
    {
      icon: <Zap size={20} />,
      text: "Uninterrupted gas, water, and electricity supply",
    },
    {
      icon: <Building2 size={20} />,
      text: "Local branches of major banks nearby",
    },
  ];

  return (
    <section id="location">
      <h2>Premium Location</h2>
      <div className="location-grid">
        {locations.map((loc, i) => (
          <motion.div
            key={i}
            className="location-card"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.6, delay: i * 0.1 }}
          >
            <p>{loc.text}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
